import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ApiEngine from "../../util/ApiEngine";
import { ApiKey, ApiUrl, getHostnameReferralCode} from "../../util/Constant";
import { setDisplayRegister, setDisplayLiveChat } from "../../redux/AppAction.js";
import { useDispatch, useSelector } from "react-redux";

const ContactUsFloatingComponent = (props) => {
  const { t, il8n } = useTranslation();
  const _dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  let communicationChannelList = useSelector((state) => state.appState.communicationChannelList);
  let isShowLiveChat = useSelector((state) => state.appState.isShowLiveChat);

  const links = [
    {
      icon: "/img/ug/floating/whatsapp.svg",
      link: "",
      word: "WhatsApp"
    },
    {
      icon: "/img/ug/floating/facebook.svg",
      link: "https://www.facebook.com/i8OfficialTeam",
      word: "Facebook"
    },
    {
      icon: "/img/ug/floating/instagram.svg",
      link: "https://instagram.com/i8.live",
      word: "Instagram"
    },
    {
      icon: "/img/ug/floating/telegram.svg",
      link: "",
      word: "Telegram"
    }
  ]


  const handleLinkOnClick = async (word, link) => {
    if (word === "WhatsApp") {
      let walink = communicationChannelList.filter((x) => { return x.channelName.includes("WhatsApp") }); 
      window.open(walink[0].cta, "_blank", 'WhatsApp');
    }
    else if (word === "Telegram") {
      let tlink = communicationChannelList.filter((x) => { return x.channelName.includes("Telegram") });
      window.open(tlink[0].cta, "_blank", 'Telegram');
    }
    else {
      window.open(link, "_blank", word)
    }
  }

  useEffect(() => {
    // Check if the third-party library has initialized CS
    if (typeof window.CS === 'undefined') {
      console.error('CS is not defined. Please ensure the third-party library is loaded.');
    }
  }, []);

  const handleOpenChat = () => {
    // Check if CS is defined and has the openChat method
    if (typeof window.CS !== 'undefined' && typeof window.CS.openChat === 'function') {
      // Call the openChat method
      window.CS.openChat(true);
    } else {
      console.error('CS or CS.openChat is not defined');
    }
  };

  return (
    <>
      <div className={`floating-contact-container ${isOpen ? "expand" : ""}`} id="contact-container">
        <div className="floating-contact-inner-container" onMouseEnter={() => { setIsOpen(true); }} onMouseLeave={() => { setIsOpen(false); }}>
          <div className="floating-img-container">
            <img src="/img/ug/floating/contact-us.svg" alt="contact" className="floating-contact-img" />
          </div>
          <div className="floating-text-container">
            <span className="floating-contact-text">{t("FLOATING_CONTACT_US")}</span>
          </div>
          <div className="floating-img-container-2">
            <img src="/img/ug/floating/right-arrow.svg" alt="right arrow" className="floating-contact-img-2" />
          </div>
        </div>

        <div className="floating-contact-hidden-container" onMouseEnter={() => { setIsOpen(true); }} onMouseLeave={() => { setIsOpen(false); }}>
          <div className="floating-24hr-container">
            <div className="floating-24hr-img-container">
              <img src="/img/ug/floating/24-hours.svg" alt="" className="floating-device-img" />
            </div>
            <div className="floating-24hr-text-container">
              24 &#x2716; 7
            </div>
          </div>

          <div className="floating-btn-container">
            <button className="custom-btn-new" onClick={handleOpenChat }>{t("LIVE_HELP")}</button>
            <button className="custom-btn-new secondary-color" onClick={() => { 
                                    const code = getHostnameReferralCode(window.location.hostname);
                                    if (code) {
                                        window.location.href = `https://${window.location.hostname}/register?code=${code}`;
                                    } 
                                    else
                                    {
                                        _dispatch(setDisplayRegister(true))
                                    }
                                    }}>{t("FLOATING_JOIN_NOW")}</button>
          </div>

          <div className="floating-quick-container">
            <img src="/img/ug/floating/clock.svg" alt="" className="floating-device-img" />
            <span className="floating-quick-text-container">{t("QUICK_EASY")}</span>
          </div>

          <div className="floating-contact-container">
            {links.map((item, index) => {
              return (
                <div key={index} className="floating-img-text-container" onClick={() => { handleLinkOnClick(item.word, item.link) }}>
                  <div className="floating-contact-img-container">
                    <img src={item.icon} alt={item.word} className="floating-contact-img" />
                  </div>
                  <div className="floating-text-contact-container">
                    <span className="floating-text-contact">{t(item.word)}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUsFloatingComponent;